import axios from "../axios";
import errorHandler from "../error-handler";
import * as uploadActions from "./upload";

export const getPersonListEntries = (listId) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/person_lists/${listId}/entries`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const createPersonListEntry = (listId, data) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/person_lists/${listId}/entries`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const updatePersonListEntry = (listId, entryId, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/person_lists/${listId}/entries/${entryId}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const deletePersonListEntry = (listId, entryId) =>
    new Promise((resolve, reject) =>
        axios
            .delete(`/person_lists/${listId}/entries/${entryId}`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const movePersonListEntry = (listId, fromIndex, toIndex) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/person_lists/${listId}/entries/move`, {
                fromIndex,
                toIndex
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const uploadPersonListImage = (listId, type, file, progressCallback) => {
    return uploadActions.upload(
        file,
        `/person_lists/${listId}/image`,
        { type },
        null,
        progressCallback
    ).promise;
};
